import store from "@/store";
import router from "@/router/index";
import { ref } from "vue";

// 用于存储上一次的登录类型
let previousLoginType = null;

// 假设这里可以从某个地方获取当前的登录类型，例如通过一个全局状态管理或者 URL 参数
// 这里简单假设从 sessionStorage 中获取登录类型，你可以根据实际情况修改
const getCurrentLoginType = () => {
  // 这里需要根据实际情况实现获取当前登录类型的逻辑
  // 例如，如果登录类型存储在 sessionStorage 中
  return sessionStorage.getItem('currentLoginType');
};

// 清除动态添加的路由
const clearDynamicRoutes = () => {
  const routes = router.getRoutes();
  routes.forEach(route => {
    if (route.name && route.name!== 'root') { // 假设根路由的 name 是 'root'，避免删除根路由
      router.removeRoute(route.name);
    }
  });
};

router.beforeEach((to, from, next) => {
  const loginType = getCurrentLoginType();
  let token = sessionStorage.getItem(`${loginType}_token`);
  let hasRoutes = store.state.hasRoutes;
  let menuList = JSON.parse(sessionStorage.getItem(`${loginType}_menuList`));
  const whiteList = ['/loginfirst', '/login/loginNextCz']; // 白名单

  // 检测登录类型是否改变
  if (previousLoginType!== null && previousLoginType!== loginType) {
    // 清除之前动态添加的路由
    clearDynamicRoutes();

    // 重置 hasRoutes 状态
    store.commit("SET_ROUTES_STATE", false);
    hasRoutes = false;
  }
  previousLoginType = loginType;

  if (token) {
    if (!hasRoutes) {
      bindRoute(menuList);
      store.commit("SET_ROUTES_STATE", true);
    }
    next();
  } else {
    // 清除 sessionStorage
    window.sessionStorage.clear();
    console.log("验证失效的路由rrrrrrrrrrrr = " + to.path);
    if (whiteList.includes(to.path)) {
      console.log("第一个界面", to.path);
      next(); // 放行
    } else {
      console.log("走到登录界面了吗？=" + to.path);
      next("/loginfirst"); // 跳转登录页面
    }
  }
});

// 动态绑定路由
const bindRoute = (menuList) => {
  let newRoutes = router.options.routes;
  if (menuList) {
    menuList.forEach(menu => {
      if (menu.children) {
        menu.children.forEach(m => {
          // 菜单转成路由
          let route = menuToRoute(m, menu.name);
          if (route) {
            newRoutes[0].children.push(route); // 添加到路由管理
          }
        });
      }
    });
  }
  // 重新添加到路由
  newRoutes.forEach(route => {
    router.addRoute(route);
  });
};

// 菜单转成路由
const menuToRoute = (menu, parentName) => {
  if (!menu.component) {
    return null;
  } else {
    let route = {
      name: menu.name,
      path: menu.path,
      meta: {
        parentName: parentName
      }
    };
    console.log("路由路径=" +  menu.component );
    route.component = () => import('@/views/' + menu.component + '.vue');
    return route;
  }
};